import { useStrings } from '../i18n/index.ts';
import { dismissPushPrimer, requestPushPermission } from '../state/push.ts';
import { Icon } from '../ui/icons.tsx';
import { Button } from '../ui/kit.tsx';
import { Sheet } from '../ui/Sheet.tsx';

/**
 * Объяснение перед вопросом о разрешении на уведомления: показывается после первого
 * оплаченного заказа, когда понятно, зачем они нужны. Системный вопрос браузера идёт только
 * после «Включить».
 */
export function PushPrimerSheet() {
  const strings = useStrings();
  return (
    <Sheet onClose={dismissPushPrimer} label={strings.pushPrimerTitle}>
      {(close) => (
        <div className="sheet-body">
          <div className="stack sheet-pad readable" style={{ gap: 18, paddingTop: 16 }}>
            <Icon name="bell" size={44} className="lead-accent" />
            <h2 className="t-display" style={{ fontSize: 28, lineHeight: 1.15 }}>
              {strings.pushPrimerTitle}
            </h2>
            <p className="t-muted">{strings.pushPrimerText}</p>
            <div className="stack" style={{ gap: 8, paddingTop: 8 }}>
              <Button onClick={() => void requestPushPermission().finally(close)}>{strings.pushPrimerAllow}</Button>
              <Button kind="secondary" onClick={close}>
                {strings.pushPrimerLater}
              </Button>
            </div>
          </div>
        </div>
      )}
    </Sheet>
  );
}
